import { connectAccountWithPlaid, getUser } from '../lib/api'

export default {
  data () {
    return {
      plaid: null,
      loading: false
    }
  },
  async mounted () {
    this.plaid = window.Plaid.create({
      apiVersion: 'v2',
      clientName: 'Small Biz Acct',
      product: ['transactions'],
      // env: 'sandbox',
      // key: 'ee62cf3f1cee7b21be3b5b3e352359',
      env: 'development',
      key: '3bb75f5d33f8369932972f336f5c59',
      onSuccess: async (publicToken) => {
        this.loading = true
        const accounts = await connectAccountWithPlaid(publicToken)
        this.$emit('updated-user-accounts', { accounts })
        this.loading = false
      }
    })
  },
  methods: {
    connectBank () {
      this.plaid.open()
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/plaid.js